import React from "react";
import SignUpContainer from "components/B/signUp/SIgnUpContainer";

const SignUpRouter = () => {
    return (
        <>
            <SignUpContainer />
        </>
    );
};

export default SignUpRouter;
